import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolBox = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "tool-box" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: 6.751,
			width: 22.5,
			height: 15,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.5,6.751a4.5,4.5,0,0,0-9,0"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 12.751,
			x2: 10.5,
			y2: 12.751
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 13.5,
			y1: 12.751,
			x2: 23.25,
			y2: 12.751
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,15a1.5,1.5,0,0,1-1.5-1.5V12a1.5,1.5,0,1,1,3,0v1.5A1.5,1.5,0,0,1,12,15Z"
		})
	]
});
export default SvgToolBox;
